import { useVendorId } from "@/features/vendors/detail/use-vendor-id";
import { VendorPaymentsPage } from "@/features/vendor-payments/vendor-payments-page";

export function VendorPaymentsTabPage() {
  const vendorId = useVendorId();
  return <VendorPaymentsPage vendorId={vendorId} embedded />;
}
